'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionDetailController = function () {
    function SelectionDetailController($scope, $state, $stateParams, ApiSelections, ApiUser, $ionicLoading, $ionicPopup, localStorageService, $rootScope) {
        _classCallCheck(this, SelectionDetailController);

        this.$state = $state;
        this.ApiSelections = ApiSelections;
        this.ApiUser = ApiUser;
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.localStorageService = localStorageService;
        this.$rootScope = $rootScope;

        this.cartItems = [];
        this.selectionId = $stateParams.selectionId;
        this.selection = {};
        this.cartItem = {};
        this.cartItem.selectionId = parseInt(this.selectionId);
        this.cartItem.numberOfUsers = this.numberOfUsers;
        this.cartItem.numberOfLicenses = 1;
        this.cartItem.cost = 0;
        this.cartItem.selectionName = '';
        this.cartItem.subtitle = '';
        this.cartItem.icon = '';
        this.user = {};
        this.childrenSelections = [];
    }

    _createClass(SelectionDetailController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });

            this.ApiUser.getUser().then(function (res) {
                _this.user = res;
            }).catch(function () {
                _this.$ionicLoading.hide();
            });

            this.ApiSelections.getSelection(this.selectionId).then(function (res) {
                _this.selection = res;
                _this.cartItem.selectionName = _this.selection.selection.selectionName;
                _this.cartItem.subtitle = _this.selection.selection.subtitle;
                _this.cartItem.icon = _this.selection.selection.icon;
                if (_this.selection) {
                    if (_this.selection.selection && _this.selection.selection.investmentType) _this.selection.selection.investmentType = _this.formatText(_this.selection.selection.investmentType);
                    if (_this.selection.selection && _this.selection.selection.country) _this.selection.selection.country = _this.formatText(_this.selection.selection.country);
                    if (_this.selection.selection && _this.selection.selection.investmentProfessionalsTypes) _this.selection.selection.investmentProfessionalsTypes = _this.formatText(_this.selection.selection.investmentProfessionalsTypes);
                }
            }).then(function () {
                // In case of 'goUniversal' the children of children packages must be displayed.
                if (_this.selection.selection.selectionName === 'goUniversal') {
                    var childrenSelectionIds = _this.selection.childrenSelections.map(function (selection) {
                        return selection.selectionId;
                    });
                    var childrenSelectionPromises = [];
                    childrenSelectionIds.forEach(function (childrenSelectionId) {
                        childrenSelectionPromises.push(_this.ApiSelections.getSelection(childrenSelectionId));
                    });

                    Promise.all(childrenSelectionPromises).then(function (res) {
                        res.forEach(function (selection) {
                            Array.prototype.push.apply(_this.childrenSelections, selection.childrenSelections);
                        });
                        _this.$ionicLoading.hide();
                    });
                } else {
                    _this.childrenSelections = _this.selection.childrenSelections;
                    _this.$ionicLoading.hide();
                }
            }).catch(function () {
                _this.$ionicLoading.hide();
            });
        }
    }, {
        key: 'openPopup',
        value: function openPopup() {
            this.$rootScope.$broadcast('cartChanged', { count: this.cartItems.length });
            this.$state.go('cart');
        }
    }, {
        key: 'addToCart',
        value: function addToCart(pricebookInfo) {
            this.cartItem.cost = pricebookInfo.unitPrice;
            this.cartItem.numberOfUsers = pricebookInfo.numberOfUsers;
            this.addSelectionInfoToCartItem();
            if (this.localStorageService.get('cart')) {
                // get the cart array and push an additional object to the array
                this.cartItems = JSON.parse(this.localStorageService.get('cart'));
                this.cartItems.push(this.cartItem);
                this.localStorageService.set('cart', JSON.stringify(this.cartItems));
                this.openPopup();
            } else {
                // create an array for shopping cart in localstorage and stringify it
                this.cartItems.push(this.cartItem);
                this.localStorageService.set('cart', JSON.stringify(this.cartItems));
                this.openPopup();
            }
        }
    }, {
        key: 'addSelectionInfoToCartItem',
        value: function addSelectionInfoToCartItem() {
            var selection = this.selection.selection;
            this.cartItem.totalNumberOfAccounts = selection.totalNumberOfAccounts;
            this.cartItem.aumThreshold = selection.aumThreshold;
        }
    }, {
        key: 'formatText',
        value: function formatText(value) {
            var array = value.split(';');
            return array.sort().join(', ');
        }
    }]);

    return SelectionDetailController;
}();

exports.default = SelectionDetailController;


/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selectionPurchase.controller.js
 **/